import {createContext} from 'react'

const AlmacenesContext = createContext()

export default AlmacenesContext